"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESPONSE_KEYS = exports.CONFIG_KEYS = void 0;
exports.CONFIG_KEYS = [
    'url',
    'method',
    'baseURL',
    'headers',
    'params',
    'data',
    'timeout',
    'timeoutErrorMessage',
    'withCredentials',
    'auth',
    'responseType',
    'xsrfCookieName',
    'xsrfHeaderName',
    'maxContentLength',
    'maxBodyLength',
    'maxRedirects',
    'socketPath',
    'proxy',
    'decompress',
];
exports.RESPONSE_KEYS = [
    'data',
    'status',
    'statusText',
    'headers',
];
